import React from "react";
import { Grid, TextField } from "@mui/material";

const toInternalName = (text = "") =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "");

const SpecialtyCakeFields = ({ item, updateItem }) => {
  const handleChange = (e) => {
    const desc = e.target.value;
    const displayName = desc || "Custom Cake";
    const internalName = toInternalName(displayName);

    updateItem(item._id, {
      customDescriptor: desc,
      displayName,
      name: internalName,
    });
  };

  return (
    <Grid item xs={12}>
      <TextField
        label="Description"
        value={item.customDescriptor || ""}
        onChange={handleChange}
        size="small"
        fullWidth
        inputProps={{ maxLength: 40 }}
      />
    </Grid>
  );
};

export default SpecialtyCakeFields;
